import { render } from "./ReasonsTab.vue?vue&type=template&id=227f81a8"
import script from "./ReasonsTab.vue?vue&type=script&lang=js"
export * from "./ReasonsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__